angular.module('membership')
  .controller('RolePermissionsCtrl', ['$scope', '$stateParams', 'rolePermissionsViewModel',

    function ($scope, $stateParams, model) {
      $scope.model = new model($stateParams.id);
    }
  ])